import { render, staticRenderFns } from "./ProductionsView.vue?vue&type=template&id=45802512"
import script from "./ProductionsView.vue?vue&type=script&lang=js"
export * from "./ProductionsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports